import { CorePersonalFields } from './CorePersonalFields'

export enum BookingClientType {
  PERSONAL = 'PERSONAL',
  BUSINESS = 'BUSINESS',
  OTHER = 'OTHER',
}

export const BOOKING_CLIENT_TYPES = [
  { value: BookingClientType.PERSONAL, label: 'Personal' },
  { value: BookingClientType.BUSINESS, label: 'Business' },
  { value: BookingClientType.OTHER, label: 'Other' },
]

export const BOOKING_CONTACT_METHODS = [
  { value: 'audio', label: 'Audio Call' },
  { value: 'video', label: 'Video Call' },
]

export type MemberBooking = CorePersonalFields & {
  bookingCategory: BookingCategory
  userNotes?: string
  occupation?: string
  accessibilityRequirements?: string
  contactMethod?: string
  selectedFile?: File
  fileUrl?: string
  bookingClientType?: BookingClientType
  bookingDateTime: Date
}

export type BookingDetailsFields = Omit<MemberBooking, 'bookingCategory' | 'bookingDateTime'>

export enum BookingCategory {
  DOCUMENT_REVIEW = 'DOCUMENT_REVIEW',
  LEGAL_ADVICE = 'LEGAL_ADVICE',
}

export const BookingCategoryLabels: Record<BookingCategory, string> = {
  [BookingCategory.DOCUMENT_REVIEW]: 'Document Review',
  [BookingCategory.LEGAL_ADVICE]: 'Legal Advice',
};

export type BookingCategoryKey = keyof typeof BookingCategory; // 'DOCUMENT_REVIEW' | 'LEGAL_ADVICE'

export type TimeSlot = {
  start: string
  end: string
}

export type BookingPayloadBase = {
  lawyer: string
  first_name: string
  last_name: string
  email: string
  phone_number: string
  appointment_type: BookingCategoryKey
  client_type: keyof typeof BookingClientType
  occupation: string
  is_video: boolean
  notes?: string
}

export type BookingPayloadLegalAdvice = BookingPayloadBase & {
  accessibility_requirements?: string
  start: string
  end: string
}

// this type ensures that either document_to_review or document_to_review_url is present, but not both
export type BookingPayloadDocumentReview = BookingPayloadBase & (
  | { document_to_review: File; document_to_review_url?: never; deadline: string }
  | { document_to_review_url: string; document_to_review?: never; deadline: string }
)

export type BookingPayload = BookingPayloadDocumentReview | BookingPayloadLegalAdvice;